exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.newsBox[data-v-5f6c9500] {\n    width: 100%;\n    margin-top: 0;\n}\n.newsBox .bannerBox[data-v-5f6c9500] {\n      width: 100%;\n      height: auto;\n}\n}\n", ""]);

